import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { Entrada } from '@shared/interfaces/entrada';
import { RespostaPaginada } from '@interfaces/respostaPaginada';

@Injectable({
  providedIn: 'root',
})
export class BuscaGlobalService {
  private readonly apiService = inject(ApiService);

  public buscarEntradas(
    termo: string,
    pagina: number,
    tamanhoPagina: number,
  ): Observable<RespostaPaginada<Entrada>> {
    const termoNormalizado = termo.trim();
    const campoBusca = /^\d+$/.test(termoNormalizado) ? 'entradaId' : 'pacienteNome';
    const params = new HttpParams()
      .set('page', String(pagina))
      .set('size', String(tamanhoPagina))
      .set(campoBusca, termoNormalizado);

    return this.apiService.get<RespostaPaginada<Entrada>>('entrada', params);
  }
}
